const errorMessage = async (response) => {
  const body = await response.json().catch(() => ({}));
  return body?.error || `Management accounts refresh failed (${response.status}).`;
};

export async function loadManagementAccounts({ accessToken }) {
  const response = await fetch('/api/management-accounts', {
    headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {}
  });
  if (!response.ok) throw new Error(await errorMessage(response));
  return response.json();
}

